<template>
  <span class="dowPdf" @click="rightShare">下载详情</span>
</template>

<script>
import {localget} from "Utils/storage";

export default {
  name:'LdEmailPopup',
  components: {
  },
  props: {
    id:'',
    djlx:'',
    orderNo:''
  },
  data() {
    return {
      pickerData: {},
      email:'',
      state:{}
    }
  },
  computed: {

  },
  created() {
    this.state = localget('VUEX_STATE') || {}
  },
  methods: {
    rightShare (){
      if(!this.id) return
      if(!this.djlx) return
      this.$api['common/generate']({
        djlx:this.djlx,
        orderId:this.id,
        imgLog:this.state.app.loginConfig.logoUrl
      }).then(res => {
        if(res.data.pdfUrl){
          const {pdfUrl} = res.data
          this.$LdDownload({ sendScene: 5, url:pdfUrl ,orderNo:this.orderNo ,orderType:this.djlx,})
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.dowPdf{
	font-size:@font-size-14 !important;
	text-decoration: underline;
}
</style>